import React from "react";
import { MantineModal } from "../mantine/modal";
import MantineButton from "../mantine/button";
import MantineFlex from "../mantine/flex";
import MantineText from "../mantine/text";
import { useStateContext } from "../../Contexts/ContextProvider";
import CustomModalHeaderTitle from "./customModalHeaderTitle";

const ConfirmationPopup = (props: any) => {
    const { onClose, handleConfirm, opened, size, ModalBodyMessage } = props
    const { currentPrimaryColor } = useStateContext();
  
    return (
        <MantineModal title={
            <CustomModalHeaderTitle  title='Confirmation' onClick={onClose}/>
        } onClose={onClose} opened={opened} size={size} centered={true}>
            <MantineText fw={400} className name={ModalBodyMessage} />
            <MantineFlex gap={15} justify='flex-center'>
                <MantineButton name={'Confirm'} className={"mt-[15px] text-sm font-thin !w-[90px]"} onClick={() => handleConfirm()} color={currentPrimaryColor} />
                <MantineButton name={'Cancel'} className={"bg-secondary_color hover:bg-hover_secondary_btn mt-[15px] text-sm font-thin !w-[100px]"} onClick={() => onClose()} />
            </MantineFlex>
        </MantineModal>
    );
};
export default ConfirmationPopup;
